import { useRoutes } from 'react-router-dom';

import routesConfig from './config';

const Routes = () => {
  return useRoutes(routesConfig);
};

export default Routes;
